enum CreatorAccountStatus {
  CREATED = 'CREATED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export default CreatorAccountStatus;
